export default {
  'Submit': 'Submit',
  'Save': 'Save',
  'enterOTP': 'Potvrdite svoj telefonski broj',
  'otpSent': 'Poslana je jednokratna lozinka',
  'login/signup': 'Welcome to OYO',
  'resendCode': 'Resend Code',
  'edit': 'Edit',
  'otpMessage': 'Enter the OTP we have sent via SMS to your mobile number',
  'oyo360WelcomeMessage': 'Dobrodošli u OYO',
  'oyo360ResendCode': 'Ponovno pošalji kôd',
  'oyo360Edit': 'Uredi',
  'oyo360otpMessage': 'Unesite kod koji smo poslali putem SMS-a na svoj broj mobitela',
  'buttonActionContinue': 'Nastaviti',
  'chooseLanguage': 'Odaberite jezik',
  'currentLanguage': 'TRENUTNI JEZIK',
  'otherLanguages': 'DRUGI JEZICI',
  'google': 'Nastavite s Googleom',
  'facebook': 'Nastavite s Facebookom',
  'or': 'ili',
  'buttonActionSubmit': 'podnijeti',
  'signingIn': 'Signing In',
  'mobileNumberPlaceholder': 'Unesite telefonski broj',
  'loginSubText': 'Unesite svoj telefonski broj kako biste postali kuća za odmor Belvilla za samo 30 minuta',
  'welcomeTitle': 'Welcome to OYO',
  'welcomeHeadingForMailLogin': 'Enter the registered email address associated with us',
  'welcomeHeadingForPhoneLogin': 'Enter the registered mobile number associated with us',
  'emailIdLabel': 'Email Id',
  'phoneNumberLabel': 'Phone number',
  'passwordLabel': 'Password',
  'newPasswordLabel': 'New Password',
  'confirmNewPasswordLabel': 'Confirm New Password',
  'emailErrorMessage': 'Please enter the correct email ID',
  'phoneNumberErrorMessage': 'Please enter the correct phone number',
  'passwordErrorMessage': 'Please enter the correct password',
  'confirmPasswordErrorMessage': 'Password is not matched!',
  'generateNewPassword': 'Generate a new password',
  'loginButtonLabel': 'Login',

  'loginWithPhoneButtonLabel': 'Continue with Phone',
  'loginWithOtp': ' Login with OTP instead',
  'loginWithEmailButtonLabel': 'Continue with Email ID',
  'back': 'Back',
  'loginWithOtpTitle': 'Enter verification code',
  'loginWithOtpHeading': 'A 6-digit code was sent to your phone number',

  'listYourProperty': 'List Your Property',
  'listProperty': 'List property',
  'privacyPolicy': ' Privacy policy',
  'termsOfUse': 'Terms of use',
  'privacyFooterText': 'By logging into the account you are agreeing with our {termsOfUse} and {privacyPolicy}',
  'and': 'and',
  'verifyEmail': 'Verify Email Address',
  'verifyMobile': 'Verify Mobile Number',
  'forgotPasswordPhoneSubHeading': 'We will send you a 6-digit code to verify your phone number',
  'forgotPasswordMailSubHeading': 'We will send you a 6-digit code to verify your email ID',
  'newPasswordCondition1': 'Should have both Number & Symbol',
  'newPasswordCondition2': 'Should have atleast 8 characters',
  'newPasswordCondition3': 'Should have both lowercase & uppercase',
  'confirmLogin': 'Confirm & Login',
  'getOTP': 'Get OTP',
  'invalidInput': 'Pogrešan unos',
  'passwordResetMessage': 'Password generated successfully',
  'otpErrorMessage': 'Please enter correct OTP',
  'resendOtpSuccessMessage': 'OTP has been resend on your mobile number successfully',
  'InternalServerErrorMessage': 'Internal Server Error',
  'resetPasswordHeading': 'A 6-digit code was sent to your email and phone number',
  'whiteSpace': ' ',
  'secureInformation': 'Ne brinite da su vaše informacije sigurne s nama',
  'termsOfService': 'Uvjeti pružanja usluge',
  'termsOfServiceFooter': 'Odabirom Nastavi u nastavku, prihvaćam sljedeće {termsOfService}',
  'notFoundText': 'We couldn\'t find the page',
  'notFoundDescription': 'Either something went wrong or the page doesn\'t exist anymore',
  'goBackFromNotFoundPage': 'Go Back',
  'goBackToOyoOs': 'Go Back to OYO OS',
  'errorNoAssociatedHotels': 'You have no Hotels associated',
  'facingIssue': 'Facing any issue? ',
  'oldLoginViewSwitch': 'Switch to Old view',
  'mobileSearchPlaceholder': 'Traži',
};
